export default function reportInstancesDirective() {
  return {
    template: require('./report-instances.html'),
    controller: 'GRReportInstancesController',
    controllerAs: 'grReportInstancesVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportInstances: '=',
    },
  };
}
